import { FormBuilder } from "components/FormBuilder/FormBuilder"
import React from 'react'
import { OnlineMerchantManagement } from "../OnlineMerchantManagement"
import transactionCurrencyOptions from "utils/transactionCurrencyOptions/TransactionCurrencyOptions"
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 */
const OnlineMerchantManagementFinanceSection = ({
  formProps,
  isCreate,
  isEditing,
  isLoading
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.merchant.financeSection" });
  const { t: tCommon } = useTranslation();

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    currencyList: {
      fieldType: "selection",
      fieldName: "currencyList",
      label: tLocal("label.currencyList"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        options: transactionCurrencyOptions("all"),
        defaultValue: ["HKD"],
        multiSelection: true
      }
    },
    gatewayFee: {
      fieldType: "textInput",
      fieldName: "gatewayFee",
      label: tLocal("label.gatewayFee"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: 1.2,
        asNumber: true,
        rules: ["onlyPositiveNumber", "maxTwoDecimal"]
      }
    },
    tokenFee: {
      fieldType: "textInput",
      fieldName: "tokenFee",
      label: tLocal("label.tokenFee"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: 0.4,
        asNumber: true,
        rules: ["onlyPositiveNumber", "maxTwoDecimal"]
      }
    },
    threeDSFee: {
      fieldType: "textInput",
      fieldName: "threeDSFee",
      label: tLocal("label.threeDSFee"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: 0.4,
        asNumber: true,
        rules: ["onlyPositiveNumber", "maxTwoDecimal"]
      }
    },
  }

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.currencyList,
              fieldsConfig.gatewayFee,
              fieldsConfig.tokenFee,
              fieldsConfig.threeDSFee
            ]
          })
        }
      </FormBuilder.Row>
      <OnlineMerchantManagement.Components.TransactionAmountLimit
        formProps={formProps}
        disabled={isDisabled}
        readOnly={isReadOnly} />
    </FormBuilder.Section>
  )
}

export default OnlineMerchantManagementFinanceSection